import "../styles/style.scss";
// Apply whitelabel branding as early as the bundle executes (before the rest of
// the landing/auth init) so customer-domain pages never flash Social Champ.
import "./whitelabel";
import $ from "jquery";
import "bootstrap";
import "owl.carousel";
import "is-in-viewport";
import init from "./header";
// import analytics from './analytics';
import contact from "./contact";
import newsletter from "./newsletter";
import pricing from "./pricing";
import localAuthentication from "./local";
import headerBanner from "./header-banner";
import offers from "./offers";
import welcome from "./welcome";
import verify2FA from "./verify-2fa";
import ssoLogin from "./ssoLogin";
import { trackAuthMethodClicks } from "./services/authEvents";
import { Alert } from "./services/components";

window.$ = $;
window.jQuery = $;
let url;

const initializeLandingPage = () => {
  $(".testimonials").owlCarousel({
    dots: true,
    items: 1,
    loop: true,
    autoplay: true,
  });

  $(".companies-logo").owlCarousel({
    dots: false,
    items: 5,
    loop: true,
    margin: 10,
    nav: true,
    navText: [$(".am-next"), $(".am-prev")],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  });

  if (
    document.location.pathname === "/post" ||
    document.location.pathname === "/signup"
  ) {
    let text;
    let imageUrl;

    const publishFrame = document.querySelector(".publish-frame");
    const bannerImg = document.querySelector(".banner-img");

    if (location.search) {
      url = new URLSearchParams(document.location.search);
      text = url.get("text");
      imageUrl = url.get("imageUrl");

      const iframe = document.querySelector("iframe.dynamic-src");
      // The login-experiment sign-up pages (z94kydcrz3) have no preview
      // frame; without this guard the throw stopped local.js from wiring the
      // form at all on any /signup URL with a query string.
      if (iframe) {
        iframe.src = iframe.src + location.search;
      }
    }

    if (document.location.pathname === "/signup" && publishFrame && bannerImg) {
      if (text || imageUrl) {
        publishFrame.classList.remove("d-none");
        bannerImg.classList.add("d-none");
      } else {
        publishFrame.classList.add("d-none");
        bannerImg.classList.remove("d-none");
        bannerImg.classList.add("d-flex");
      }
    }
  }

  const publishLi = document.getElementById("publish-li");

  if (publishLi) {
    document
      .getElementById("publish-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("publish-li").getAttribute("class"))
          document.getElementById("publish-li").removeAttribute("class");
        else {
          document
            .getElementById("publish-li")
            .setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/hiw-image.png");
        }
      });
    document
      .getElementById("engage-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("engage-li").getAttribute("class"))
          document.getElementById("engage-li").removeAttribute("class");
        else {
          document
            .getElementById("engage-li")
            .setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/engage.png");
        }
      });

    document
      .getElementById("analyze-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("analyze-li").getAttribute("class"))
          document.getElementById("analyze-li").removeAttribute("class");
        else {
          document
            .getElementById("analyze-li")
            .setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/analytics.png");
        }
      });

    document
      .getElementById("team-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("team-li").getAttribute("class"))
          document.getElementById("team-li").removeAttribute("class");
        else {
          document.getElementById("team-li").setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/hiw-image.png");
        }
      });

    document
      .getElementById("calendar-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("calendar-li").getAttribute("class"))
          document.getElementById("calendar-li").removeAttribute("class");
        else {
          document
            .getElementById("calendar-li")
            .setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/all-in-one-calendar.jpg");
        }
      });

    document
      .getElementById("social-media-li")
      .firstElementChild.addEventListener("click", function () {
        if (document.getElementById("social-media-li").getAttribute("class"))
          document.getElementById("social-media-li").removeAttribute("class");
        else {
          document
            .getElementById("social-media-li")
            .setAttribute("class", "active-li");
          document
            .getElementById("hiw-img")
            .setAttribute("src", "/assets/images/home/hiw-image.png");
        }
      });
  }

  const copyYearElement = document.getElementById("copy-year");
  if (copyYearElement) {
    copyYearElement.innerText = new Date().getFullYear();
  }

  $(window).scroll(() => {
    const videos = $(".scroll-video");
    if (videos) {
      videos.each(() => {
        try {
          if (videos.is(":in-viewport")) {
            videos[0].play();
          } else {
            videos[0].pause();
          }
        } catch (e) {
          console.error(e);
        }
      });
    }
  });

  function planCheckbox() {
    const banner = document.getElementById("new-year-banner");
    const pricing = document.getElementById("pricing-cards");
    const prcingSwicthText = document.getElementById("pricing-switch-text");
    if (!banner || !pricing || !document.getElementById("pricing-switch")) {
      return;
    }
    document
      .getElementById("pricing-switch")
      .addEventListener("change", (event) => {
        if (event.target.checked) {
          banner.classList.remove("view-annual");
          pricing.classList.remove("view-annual");
          banner.classList.add("view-month");
          pricing.classList.add("view-month");
          prcingSwicthText.innerText = "Monthly";
        } else {
          pricing.classList.remove("view-month");
          banner.classList.remove("view-month");
          banner.classList.add("view-annual");
          pricing.classList.add("view-annual");
          prcingSwicthText.innerText = "Annually";
        }
      });
  }

  function checkErrorMessage() {
    const params = new URL(window.location).searchParams;
    if (params.get("error") === "true" && params.get("message")) {
      Alert.error(params.get("message"));
      // window.location.search = '';
    } else if (params.get("success") === "true" && params.get("message")) {
      Alert.success(params.get("message"));
      // window.location.search = '';
    }
  }

  planCheckbox();
  init();
  // analytics();
  contact();
  newsletter();
  pricing();
  localAuthentication();
  headerBanner();
  offers();
  checkErrorMessage();
  welcome();
  verify2FA();
};

// Google/SSO choice on every auth page, control and experiment arms alike.
trackAuthMethodClicks(document, window.location);

// SSO runs on its own, as it did when it was an inline script: a throw in any
// landing-page initializer must not leave /sso-login without its submit handler.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", ssoLogin);
} else {
  ssoLogin();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeLandingPage);
} else {
  initializeLandingPage();
}
